import axios from 'axios'
const ShopOrderListModule = {
  namespaced: true,
  state: {
    data: [],
    dialog: false,
    idx: ''
  },
  mutations: {
    UPDATE_DIALOG: (state, payload) => {
      state.dialog = payload
    },
    SET_IDX: (state, payload) => {
      state.idx = payload
    },
    FETCH: (state, payload) => {
      state.data = payload
    },
    DELETE: (state, payload) => {
      let index = state.data.findIndex(data => data.idx === payload)
      state.data.splice(index, 1)
    },
    INSERT: (state, payload) => {
      // state.data.push(payload)
      let index = state.data.findIndex(data => data.idx === payload.idx)
      state.data[index] = payload
    },
    UPDATE: (state, payload) => {
      let index = state.data.findIndex(data => data.idx === payload.idx)
      state.data[index] = payload
    }
  },
  actions: {
    async fetch({ commit }) {
      try {
        const response = await axios.get(`farmerspace/shop/order`)
        commit('FETCH', response.data)
      } catch (error) {
        throw new Error(error)
      }
    },
    async delete({ commit, dispatch }, payload) {
      try {
        const response = await axios.delete(`farmerspace/shop/order/${payload}`)
        if (response.data.message === true) {
          commit('DELETE', payload)
          const notification = {
            type: 'success',
            message: 'Deleted'
          }
          dispatch('Notification/add', notification, { root: true })
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    async insert({ commit, dispatch }, payload) {
      try {
        const response = await axios.post(`farmerspace/shop/order`, payload)
        if (response.data.message === true) {
          dispatch('fetch')
          commit('INSERT', payload)
          return response.data.idx
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    async updateSlip({ commit, dispatch }, payload) {
      try {
        const response = await axios.put(`farmerspace/shop/order/slip`, payload)
        if (response.data.message === true) {
          dispatch('fetch')
          commit('INSERT', payload)
          const notification = {
            type: 'success',
            message: 'Slip Updated'
          }
          dispatch('Notification/add', notification, { root: true })
        }
      } catch (error) {
        throw new Error(error)
      }
    }
  },
  getters: {
    getAll: state => {
      return state.data
    },
    getById: state => payload => {
      return state.data.filter(item => item.idx.match(payload))
    }
  }
}

export default ShopOrderListModule
